import { Confirmation } from "@jewlr/storybook/modal"
import { goBack, replace } from "connected-react-router"
import PropTypes from "prop-types"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { connect } from "react-redux"

import { history } from "app-store-v2"
import {
  doLogout,
  deactivateAccountMenu,
  setHeaderDropdown,
} from "app-store-v2/app/actions"

const LogoutModal = ({ handleLogout, hideModal, routerHash }) => {
  const [show, setShow] = useState(false)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    return () => (mounted.current = false)
  }, [])

  useEffect(() => {
    if (mounted.current) {
      setShow(routerHash === "#logout")
    }
  }, [routerHash])

  useLayoutEffect(() => {
    if (routerHash === "#logout") {
      hideModal()
    }
  }, [])

  return (
    <Confirmation
      cancelText="Cancel"
      confirmText="Yes"
      description="Are you sure you want to logout?"
      onCancel={() => hideModal()}
      onConfirm={() => {
        handleLogout()
        hideModal()
      }}
      show={show}
      title="Logout"
    />
  )
}

LogoutModal.propTypes = {
  handleLogout: PropTypes.func,
  hideModal: PropTypes.func,
  routerHash: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    lastRouterAction: state.router.action,
    routerHash: state.router.location.hash,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handleLogout: () => {
      dispatch(setHeaderDropdown(""))
      dispatch(deactivateAccountMenu())
      dispatch(doLogout())
    },
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { lastRouterAction } = stateProps
  const { dispatch } = dispatchProps
  const routerAction = lastRouterAction === "PUSH" ? goBack : replace

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    hideModal: () => {
      dispatch(
        routerAction(`${history.location.pathname}${history.location.search}`)
      )
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LogoutModal)
